// extracted by mini-css-extract-plugin
export default {"root":"NetworkError-root-ee80d312c9af76ef6d59f05a020e39bc"};